module.exports = __webpack_public_path__ + "img/安全巡检-bg.a586d0ad.jpg";